import type { IPermissionRule } from 'features/permissions/role-rules';

export type JobActionId =
  | 'edit'
  | 'duplicate'
  | 'export'
  | 'share'
  | 'unpublish'
  | 'publish'
  | 'archive'
  | 'drafts';

type JobActionInput = {
  job: { isPublished: boolean; isArchived: boolean };
  hasManageAccess: boolean;
  hasRolePermission: (permission: IPermissionRule) => boolean;
};

/** Shared by the list and job page menus so they cannot diverge. */
export const visibleJobActions = ({
  job,
  hasManageAccess,
  hasRolePermission,
}: JobActionInput): Set<JobActionId> => {
  const isLive = !job.isArchived && job.isPublished;
  const isDraft = !job.isArchived && !job.isPublished;
  const visible = new Set<JobActionId>();

  if (hasManageAccess) visible.add('edit');
  if (hasRolePermission('job:duplicate')) visible.add('duplicate');
  if (hasRolePermission('job:export')) visible.add('export');
  if (isLive) visible.add('share');
  if (hasManageAccess && isLive) visible.add('unpublish');
  if (hasManageAccess && isDraft) visible.add('publish');
  if (hasManageAccess && !job.isArchived) visible.add('archive');
  if (hasManageAccess && job.isArchived) visible.add('drafts');

  return visible;
};
